export const OTPValidate = /^\d+$/;
